export default function validate(values, props) {
    const { messages, returnOrExchange } = props
    const errors = {}

    if (!values.returnOrExchange) {
        errors.returnOrExchange = messages.returnsAndExchangesForm.requiredReturnType()
    }

    if (!values.reasonCode) {
        errors.reasonCode = messages.returnsAndExchangesForm.requiredReturnCode()
    }

    if (!values.reasonNote) {
        errors.reasonNote = messages.returnsAndExchangesForm.requiredReturnNote()
    }

    if (returnOrExchange === 'exchange' && !values.exchangePartnumber) {
        errors.exchangePartnumber = messages.returnsAndExchangesForm.requiredSize()
    }

    return errors
}
